import React from 'react';
import { connect, useSelector } from 'react-redux';
import UpdateViewLocalAccessHoursContent from '../components/pages/waiting-area/update-view-local-access-hours/content';

function WaitingAreaLocalAccessHoursPage(props) {
  const waitingAreaLocalAccessHoursForm = useSelector(
    (state) => state.waitingAreaReducer.waitingAreaLocalAccessHoursForm
  );
  const showUpdateWaitingAreaLocalAccessHoursModal = useSelector(
    (state) => state.modalReducer.showUpdateWaitingAreaLocalAccessHoursModal
  );
  const showViewWaitingAreaLocalAccessHoursModal = useSelector(
    (state) => state.modalReducer.showViewWaitingAreaLocalAccessHoursModal
  );

  return (
    <div>
      <UpdateViewLocalAccessHoursContent
        waitingAreaLocalAccessHoursForm={waitingAreaLocalAccessHoursForm}
        waitingArea={props.waitingArea}
        showViewWaitingAreaLocalAccessHoursModal={showViewWaitingAreaLocalAccessHoursModal}
        showUpdateWaitingAreaLocalAccessHoursModal={showUpdateWaitingAreaLocalAccessHoursModal}
        updateOrView={props.updateOrView}
      />
    </div>
  );
}

export default WaitingAreaLocalAccessHoursPage;
